import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import React, { MouseEventHandler, useContext, useState } from 'react'
import styles from './styles.module.css'
import VanFormComponent from './VanFormComponent'
import SecondaryButton from '../../../global/components/buttons/secondary-button/SecondaryButton'
import PrimaryButton from '../../../global/components/buttons/primary-button/PrimaryButton'
import { IVan, IVanPartial } from '../../../../../app/entities/Van'
import { fetchData } from '../../../global/utils/fetch'
import { createVan, setVanToLocation } from '../../api'
import { ToastNotificationContext } from '../../../global/context/ToastNotificationContext'
import CircularProgress from '@mui/material/CircularProgress'
import { IRefreshCounterProps } from '../../main/VansMain'
interface INewVanModalProps {
  isOpen: boolean
  handleClosed: Function
  refresh: IRefreshCounterProps
}
function NewVanModal(props: INewVanModalProps) {
  const { isOpen, handleClosed } = props
  const { refreshCounter, setRefreshCounter } = props.refresh
  const [isLoading, setIsLoading] = useState(false)
  const [selectedLocation, setSelectedLocation] = useState<string>('')
  const { toastStatus, setToastStatus } = useContext(ToastNotificationContext)
  const [newVanFormData, setNewVanFormData] = useState<IVanPartial | null>({
    name: '',
    active: true,
  })

  const doesNameExist = (newVanFormData?.name ?? '').trim().length > 0
  const isLocationSelected = selectedLocation !== ''

  const handleCreateVan = async (e: any) => {
    const trimmedName = newVanFormData?.name?.trim() ?? ''
    const isActive = newVanFormData?.active ?? true

    if (trimmedName.length === 0 || !isLocationSelected) {
      console.error('Required fields are not filled.')
      return
    }

    try {
      setIsLoading(true)
      const van = await fetchData<IVan>(createVan(isActive, trimmedName))
      await fetchData(setVanToLocation(van.objectId, selectedLocation))
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Successfully created van!',
        severity: 'success',
      })
      setRefreshCounter(() => refreshCounter + 1)

      handleClosed(e)
    } catch (error) {
      console.error('Error creating van:', error)
      setToastStatus({
        ...toastStatus,
        isOpen: true,
        message: 'Error Creating Van',
        severity: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Modal
        open={isOpen}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box className={styles.newVanModal}>
          <div className={styles.contentContainer}>
            <div className={`${styles.newVanModalPageTitle} font--bold`}>
              Create New Van
            </div>
            <VanFormComponent
              setSelectedLocation={setSelectedLocation}
              vanFormData={newVanFormData}
              setVanFormData={setNewVanFormData}
            />
            {isLoading && (
              <div className={styles.progressContainer}>
                <CircularProgress />
              </div>
            )}
            <div className={styles.buttonContainer}>
              <SecondaryButton
                buttonName='Cancel'
                onClick={handleClosed as MouseEventHandler}
              />
              <PrimaryButton
                buttonName='Create'
                onClick={handleCreateVan}
                disabled={!doesNameExist || !isLocationSelected || isLoading}
              />
            </div>
          </div>
        </Box>
      </Modal>
    </>
  )
}

export default NewVanModal
